import React, { useState, useEffect } from "react";
import useForm from '../../hooks/useForm';
import useFetch from '../../hooks/useFetch'
import { FormField,  Modal, Button } from '@prosolve/common-components-ui'
import { FaTrash } from 'react-icons/fa';
import useDataTrainers from '../../dataHooks/useDataTrainers'
// import useDataAttendees from "../../../../dataHooks/useDataAttendees";

export default ({
  sessionData = {},
  isStarConsultationSession,
  onClose,
  onSuccess,
}) => {
  const {
    isLoading,
    trainers,
    fetchTrainers
  } = useDataTrainers()

  const { eventId } = sessionData;

  useEffect(() => {
    fetchTrainers({ eventId })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  const [filterOptionsVal, setFilterOptionsVal] = useState()

  const trainerOptions = trainers
  .reduce(function(filtered, trainer) {
    const { id = '', name = '' } = trainer;

    let passesFilter;
    if (filterOptionsVal) {
      if (name.toLowerCase().includes(filterOptionsVal.toLowerCase()) || id.toLowerCase().includes(filterOptionsVal.toLowerCase())) {
        passesFilter = true;
      } else {
        passesFilter = false;
      }
    } else {
      passesFilter = true;
    }

    if (passesFilter) {
      filtered.push({ value : id, text: name });
    }

    return filtered;
  }, [])
  .sort(({ text: textA }, {text: textB }) => {
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  })

  const formSchema = isStarConsultationSession ?
  {
    requiredFields: [],
    optionalFields: ['schoolName', 'address', 'teacherName', 'teacherEmail', 'trainerLeadId', 'notes', 'classroomType', 'slideDeckLinkOverride', 'hideSlideDeckLink'], // 'eventBlueprintDocument'
    initData: sessionData
  } :
  {
    requiredFields: [], //,'description'],
    optionalFields: ['location', 'trainerLeadId', 'slideDeckLinkOverride', 'hideSlideDeckLink'], // 'eventBlueprintDocument'
    initData: sessionData
  };

  const formData = useForm(formSchema)

  const [isBusy, setIsBusy] = useState(false);

  const fetch = useFetch()

  const onClickSubmit = async () => {
    if (!isBusy && formData.isValid()) {
      setIsBusy(true) 

      const submitValues = { ...formData.values }
      delete submitValues.trainerLeadJunk;

      if (submitValues.trainerLeadId) {
        // find matching trainer lead name
        const trainerObj = trainers.find(({ id }) => id === submitValues.trainerLeadId)
        if (trainerObj && trainerObj.name) {
          submitValues.trainerLeadName = trainerObj.name;
        }
      } else {
        // Ensure if trainerLeadId was clear...we set the name value to empty
        submitValues.trainerLeadName = '';
      }

      try {
        const response = await fetch(`events/event/session/update`, {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: { ...submitValues, _id: sessionData._id } })
        })
        const jsonData = await response.json()

        if (jsonData.success) {
          setIsBusy(false)
          onSuccess()
        }
      } catch (e) {
        console.log(e)
      }

      setIsBusy(false)

      onClose()
    }
  }
  
  const [force, setForce] = useState(false)

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Submit'}
      </Button>
    </div>
  )

  return (
    <Modal title={'Edit Session'} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        { !isStarConsultationSession &&
          <FormField
            style={{ flex: 1 }}
            fieldId='location'
            type='text'
            label='Location'
            placeholder=''
            formData={formData}
          />
        }
        { isStarConsultationSession &&
          <>
          <FormField
            style={{ flex: 1 }}
            fieldId='schoolName'
            type='text'
            label='Name of School'
            placeholder=''
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='address'
            type='text'
            label='Address'
            placeholder=''
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='teacherName'
            type='text'
            label='Name of Teacher'
            placeholder=''
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='teacherEmail'
            type='text'
            label='Teacher Email'
            placeholder=''
            formData={formData}
          />
          </>
        }
        <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', flex: 1 }}>
          { !force ?
            <FormField
              style={{ flex: 1 }}
              // fieldStyle={{ flex: 1 }}
              fieldId='trainerLeadId'
              type='search'
              label='Trainer Lead'
              placeholder=''
              isLoading={isLoading}
              onSearch={(val) => setFilterOptionsVal(val)}
              options={trainerOptions}
              formData={formData}
              width='100%'
              maxHeight='200px'
            />
            : // Needed to force a refresh of the component by flipping to a junk one and then back
            <FormField
              style={{ flex: 1 }}
              fieldId='trainerLeadJunk'
              type='text'
              label='Trainer Lead'
              placeholder=''
              formData={formData}
              width='100%'
              maxHeight='200px'
            />
          }
        </div>
          <Button
            style={{
              height: '19px',
              border: 'none',
              marginTop: '20px',
              marginLeft: '10px'
            }}
            onClick={() => {
              formData.setValues({ ...formData.values, trainerLeadId: '' })
              setForce(true)
              setTimeout(() => {
                setForce(false)
              }, [1])
            }}
          >
            <FaTrash style={{ color: '#ef0c0c' }} />
            <div style={{ color: '#ef0c0c', fontSize: '12px', marginLeft: '5px' }}>Remove</div>
          </Button>
        </div>
        { isStarConsultationSession &&
          <FormField
            style={{ flex: 1 }}
            fieldId='notes'
            type='text'
            label='Notes'
            placeholder=''
            formData={formData}
          />
        }
        { isStarConsultationSession &&
          <FormField
            style={{ flex: 1 }}
            fieldId='classroomType'
            type='text'
            label='Classroom Type'
            placeholder=''
            formData={formData}
          />
        }
        <FormField
          style={{ flex: 1 }}
          fieldId='slideDeckLinkOverride'
          type='text'
          label='Override Template Slide Deck Link'
          placeholder=''
          formData={formData}
        />
        <FormField
          fieldId='hideSlideDeckLink'
          type='checkbox'
          label='Hide Slide Deck Link'
          formData={formData}
        />
      </div>
    </Modal>
  )
}